import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { LOSS_REASONS } from "../../utils/crmLossReason";

const CrmLossReasonModal = ({ open, leadName, onConfirm, onCancel, saving = false }) => {
  const [reason, setReason] = useState("price");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (open) {
      setReason("price");
      setNote("");
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="crm-loss-modal" role="dialog" aria-modal="true" aria-label="Loss reason">
      <button type="button" className="crm-loss-modal__backdrop" onClick={onCancel} aria-label="Close" />
      <div className="crm-loss-modal__panel">
        <div className="crm-loss-modal__header">
          <h3>Why did we lose this lead?</h3>
          <button type="button" onClick={onCancel} aria-label="Close">
            <X size={18} />
          </button>
        </div>
        <p className="crm-loss-modal__sub">
          {leadName ? `Recording loss reason for ${leadName}` : "Help your team improve conversion analytics."}
        </p>

        <div className="crm-loss-modal__reasons">
          {LOSS_REASONS.map((r) => (
            <label key={r.id} className={`crm-loss-modal__chip${reason === r.id ? " is-selected" : ""}`}>
              <input
                type="radio"
                name="lossReason"
                value={r.id}
                checked={reason === r.id}
                onChange={() => setReason(r.id)}
              />
              {r.label}
            </label>
          ))}
        </div>

        <textarea
          className="crm-loss-modal__note"
          placeholder="Optional notes (competitor name, objection details…)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={3}
        />

        <div className="crm-loss-modal__actions">
          <button type="button" className="crm-loss-modal__cancel" onClick={onCancel} disabled={saving}>
            Cancel
          </button>
          <button
            type="button"
            className="crm-loss-modal__confirm"
            onClick={() => onConfirm(reason, note)}
            disabled={saving}
          >
            {saving ? "Saving…" : "Mark not interested"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrmLossReasonModal;
